import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n'; // Initialize i18n
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ServiceWorkerProvider } from './contexts/ServiceWorkerContext';

// NOTE: Stream interceptor for Android mic sharing was attempted but Web Speech API
// doesn't work with cloned streams. Keeping the simpler approach:
// - Voice START trigger works (mic released before recognition)
// - Voice STOP trigger disabled during recording (mic conflict)
// - Beeping fixed with exponential backoff delays

// DEBUG: Log when React app initializes (full page load/reload)
console.log('[index.js] React app initializing at', new Date().toISOString());
console.log('[index.js] Page load count this session:', (parseInt(sessionStorage.getItem('pageLoadCount') || '0', 10) + 1));
sessionStorage.setItem('pageLoadCount', (parseInt(sessionStorage.getItem('pageLoadCount') || '0', 10) + 1).toString());

// DEBUG: Catch uncaught errors that might cause reload
window.addEventListener('error', (event) => {
  console.error('[index.js] UNCAUGHT ERROR:', event.error?.message || event.message, event.error?.stack);
});
window.addEventListener('unhandledrejection', (event) => {
  console.error('[index.js] UNHANDLED PROMISE REJECTION:', event.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ServiceWorkerProvider>
        <App />
      </ServiceWorkerProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
